module.exports = __webpack_public_path__ + "img/new_arts.6d90cf68.svg";